export const config = {
	apiBasePath: window.location.hostname === 'localhost' ? 'http://localhost:7071/api/' : `/api/`,
};
